import axios from "axios";
import { base_url } from "../../../utils/baseUrl";

const getUpdates = async (token) => {
  const response = await axios.get(`${base_url}updates/getUpdate`,{
    
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
      }
  });
 
  return response.data;
  
};
const createUpdate = async (values) => {
  const token = values.token;
  
  const response = await axios.post(
    `${base_url}updates/addUpdate`,
    values, // Pass form data directly
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
      },
    }
  );

  return response.data;
};
const updateUpdate = async (values) => {
  
  const response = await axios.put(
    `${base_url}updates/editUpdate/${values.id}`,
    values.NewsData,

  );

  return response.data;
};

const getUpdate = async (id) => {
  const response = await axios.get(`${base_url}updates/getById/${id}`);

  return response.data;
};

const deleteUpdate = async (id) => {
  const response = await axios.delete(`${base_url}updates/deleteUpdate/${id}`);

  return response.data;
};
const UpdateService = {
  getUpdates,
  createUpdate,
  getUpdate,
  updateUpdate,
  deleteUpdate,
};

export default UpdateService;
